<template>
    <div>
        <component-loader
            :key="$i18n.locale"
            v-if="componentInitialized"
            :component-name="componentName"
            :default-component-name="defaultComponentName"
            id="monitoring-component"
        >
        </component-loader>
    </div>
</template>
<script>
    import ComponentLoader from './ComponentLoader';
    import {MonitoringService, GrantService, UserRoles, FileUploadService, MonitoringForm} from '@/services';
    import {EventBus} from '@/event-bus.js';

    export default
    {
        components:
        {
            ComponentLoader,
        },
        data()
        {
            return {
                MonitoringForm,
                grantId: parseInt(this.$route.params.grantId) || null,
                applicationId: parseInt(this.$route.params.applicationId) || null,
                componentInitialized: false,
                componentName: 'Dynamic',
                defaultComponentName: 'Default',
                loggedUser: {},
            }
        },
        beforeMount()
        {
            this.loggedUser = this.$store.getters['Auth/loggedUser'];
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            const grantId = parseInt(this.$route.params.grantId);
            const applicationId = parseInt(this.$route.params.applicationId);
            const objectAssignDeep = require('object-assign-deep');

            MonitoringForm.init();

            MonitoringForm.grantId = grantId;
            MonitoringForm.applicationId = applicationId;

            await GrantService.get(grantId).then((response) =>
            {
                // debugger;
                if (response.data.type === 'static')
                {
                    vm.componentName = response.data.componentName;
                }

                MonitoringForm.model = {grant_agreement: {}, logical: {}, technical: {}};
                MonitoringForm.files = {grant_agreement: {}, logical: {}, revised_logframe: {}};
                // MonitoringForm.cnEvaluationStatus=response.data.cnStatus;

                vm.componentInitialized = true;
            });

            MonitoringForm.initialized = false;
            MonitoringForm.isEditable = false;

            await MonitoringService.getAwardedApplication({
                grantId: grantId,
                applicationId: applicationId
            }).then((response) =>
            {
                MonitoringForm.model = objectAssignDeep(MonitoringForm.model, response.data.data);
                MonitoringForm.files = {...MonitoringForm.files, ...response.data.files};
                MonitoringForm.newApplication=response.data.new_application;
                MonitoringForm.cnEvaluationStatus=response.data.cn_evaluation_status;


                if(response.data.data.title){
                    MonitoringForm.title = response.data.data.title;
                } else {
                    MonitoringForm.title = response.data.title;
                }

                MonitoringForm.organisation = response.data.organisation;
                MonitoringForm.reference = response.data.reference;

                MonitoringForm.initialized = true;

                if (vm.loggedUser.role !== UserRoles.AUDITOR)
                {
                    MonitoringForm.isEditable = true;
                }

                // setting filesize limit to state
                MonitoringForm.fileSizeLimit = response.data.upload_max_filesize;
            });

            loader.hide();
        },
        mounted()
        {
            const vm = this;

            EventBus.$off('monitoring-save-progress');
            EventBus.$on('monitoring-save-progress', data => { vm.saveProgress(); });

            EventBus.$off('monitoring-submit');
            EventBus.$on('monitoring-submit', data => { vm.submitt(); });
        },
        methods:
        {
            async saveProgress(status)
            {
                const vm = this;
                const loader = vm.$loading.show();

                MonitoringForm.model.title = MonitoringForm.title;

                await MonitoringService.updateMonitoring({
                    applicationId: MonitoringForm.applicationId,
                    model: MonitoringForm.model,
                    status: status
                }).then((response) =>
                {

                });

                await vm.uploadFiles();

                loader.hide();
            },

            async submitt()
            {
                this.saveProgress('submit');
            },

            async uploadFiles()
            {
                const vm = this;
                let files = MonitoringForm.files;
                let promises = [];
                let section;
                let sub_section;

                for (section in files)
                {
                    if (files.hasOwnProperty(section))
                    {
                        for (sub_section in files[section])
                        {
                            if (files[section].hasOwnProperty(sub_section))
                            {
                                let file_to_upload = files[section][sub_section];

                                if (file_to_upload instanceof File)
                                {
                                    let form_data = new FormData();

                                    form_data.append('file', file_to_upload);
                                    form_data.append('section', file_to_upload.section);
                                    form_data.append('$section', section);

                                    if (file_to_upload.id)
                                    {
                                        form_data.append('id', file_to_upload.id);
                                    }

                                    let promise = FileUploadService.uploadMonitoringFiles({
                                        applicationId: MonitoringForm.applicationId,
                                        formData: form_data
                                    }).then((response) =>
                                    {
                                        const fd_section = form_data.get('$section');
                                        const fd_sub_section = form_data.get('$sub_section');

                                        files[fd_section][fd_sub_section] =
                                        {
                                            id: response.data.id,
                                            name: response.data.filename,
                                            download: response.data.download
                                        };
                                    }).catch((error) => console.log('error: ', error));

                                    promises.push(promise);
                                }
                            }
                        }
                    }
                }

                return await Promise.all(promises);
            }
        },
    };
</script>
